/* ===================================================================
   Chute OAuth-return resume flag (2026-07-09).

   The Google connect step of the linear chute (routes/Welcome) sends the owner
   out to Google's OAuth screen. The backend oauth_flow returns them to
   /integrations (a fixed redirect we do not change). To keep the linear chute
   experience unbroken, the connect step sets this sessionStorage flag before it
   leaves; ChuteResumeSync (mounted app-wide in App.tsx) sees it on the
   /integrations landing and bounces the owner back to /welcome, which re-derives
   nextStep and lands them on the right step (test, once Google is connected;
   still connect if the listing needs confirming).

   sessionStorage (not localStorage): it must survive the full-page OAuth
   round-trip but not leak across sessions.
   =================================================================== */
export const CHUTE_RESUME_FLAG = 'rhody_chute_resume';

export function consumeChuteResume(): boolean {
  try {
    const v = sessionStorage.getItem(CHUTE_RESUME_FLAG);
    if (v === '1') {
      sessionStorage.removeItem(CHUTE_RESUME_FLAG);
      return true;
    }
  } catch {
    /* non-fatal */
  }
  return false;
}

/* The OAuth callback returns the owner to /integrations?google=<status>. When
   the connect was launched from the chute, ChuteResumeSync bounces them back to
   /welcome -- but the internal /welcome -> /welcome/connect redirect drops query
   params, so a scope_insufficient / error status would be lost. We stash it in
   sessionStorage on the /integrations landing and the chute's ConnectStep
   consumes it, so a scope-less connect shows a clear "grant Business Profile
   access" message instead of silently looping back to the Connect button. */
export const CHUTE_GOOGLE_RETURN = 'rhody_chute_google_return';

export function stashChuteGoogleReturn(status: string | null): void {
  try {
    if (status) sessionStorage.setItem(CHUTE_GOOGLE_RETURN, status);
  } catch {
    /* non-fatal */
  }
}

export function consumeChuteGoogleReturn(): string | null {
  try {
    const v = sessionStorage.getItem(CHUTE_GOOGLE_RETURN);
    if (v) {
      sessionStorage.removeItem(CHUTE_GOOGLE_RETURN);
      return v;
    }
  } catch {
    /* non-fatal */
  }
  return null;
}
